import { LocalizedAttributesValue } from 'src/generated/operations';

const regexp = new RegExp('accessory', 'i');

export function isAccessory(attr: LocalizedAttributesValue): boolean {
  return !!attr && !!attr.raw && regexp.test(attr.raw.join(''));
}
